import { IktvaFile } from "./iktvaFileModel";

export class IktvaForm {
  Id: string | null = null;
  CompanyName: string = '';
  CommercialRegistrationNumber: string = '';
  HalVendorNumber: string = '';
  BusinessSegmentId: number = 0;
  BusinessDescription: string = '';
  Address: string = '';
  City: string = '';
  Country: string = '';
  CompanyEmail: string = '';
  CompanyContactPerson: string = '';
  PhoneContactPerson: string = '';
  EmailContactPerson: string = '';
  AnnualRevenueMoreThan: boolean = false;
  TotalEmployeesMoreThan: boolean = false;
  TotalEmployees: number = 0;
  TotalSaudiEmployees: number = 0;
  TotalQualityEmployees: number = 0;
  TotalManufacturingEmployees: number = 0;
  TotalEngineeringEmployees: number = 0;
  ManufacturingDivArea: number = 0;
  ApiCertification: boolean = false;
  SmeCertification: boolean = false;
  IsoCertification: boolean = false;
  ErpSystem: boolean = false;
  AnnualAuditReportToAramco: boolean = false;
  ExportingOutsideSaudi: boolean = false;
  RequireHalSupport: boolean = false;
  PreviousYearIktvascore: string = '';
  PreviousYearRevenue: string = '';
  PreviousYearReportType: number = 0;
  CurrentYearEstimatedScore: string = '';
  CurrentYearEstimatedRevenue: string = '';
  ServicesProvidedIds: number[] = [];
  OtherService: string = '';
  MaterialProductionTypeId: number = 0;
  SpendLocalizedServices: string = '';
  SpendCompensationSaudiNationals: string = '';
  SpendTrainingSaudiNationals: string = '';
  SpendSupplierDevelopment: string = '';
  SpendResearch: string = '';
  Iktvaplan: string = '';
  MajorContracts: string = '';
  RawMaterialSourceId: number | null = null;
  QualityManagementSystem: boolean = false;
  InternalQualityAudit: boolean = false;
  CreatedDate: Date | string | null = null;
  LastUpdatedDate: Date | string | null = null;
  UniqueIktvaId: string = '';
  Year: string = '';
  IktvaFiles: IktvaFile[] = [];
}
